<template>
    <div>
        <SpinnerItem v-show="isLoading"></SpinnerItem>
        <div v-show="!isLoading" class="profile">
            <h2>Fiskere for {{profileName}}</h2>
            <div v-for="c in catchers" :key="c.Id">
                <CatcherCard :catcher="c" />
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { Bus, Stops } from '../../common/bus';
import SpinnerItem from '../common/SpinnerItem.vue';
import CatcherCard from '../catchers/CatcherCard.vue';

export default {
    components: { SpinnerItem, CatcherCard },
    watch: {
        profile(profile) {
            if (!profile) return;
            Bus.$emit(Stops.TITLE_CHANGED, `Profil for ${profile.name}`);
        },
    },
    computed: {
        ...mapState('session', ['profile', 'isLoading', 'catchers']),
        profileName() {
            return this.profile ? this.profile.name : null;
        },
    },
    created() {
        Bus.$emit(Stops.NAVBAR, 'ProfilePage');
        if (!this.profile) return;
        Bus.$emit(Stops.TITLE_CHANGED, `Profil for ${this.profile.name}`);
    },
    methods: {
        ...mapActions('session', ['unloadProfile']),
    },
};
</script>

<style lang="scss" scoped>
.profile {
    display: flex;
    margin: auto;
    max-width: $maxContentWidth;
    flex-direction: column;
    flex: 1;
    h2 {
        background: white;
        font-size: 1.1rem;
        flex: 1;
        text-align: center;
    }
}
.logout {
    position: relative;
    cursor: pointer;
    font-size: 0.7rem;
    background-color: $backgroundColor;
    padding: 0rem 0.5rem 0.1rem 0.5rem;
    transition: all 0.2s ease-in-out;
    border: 1px solid lightgrey;
    border-radius: 4px;
    top: 0.1rem;
    left: 0.1rem;
    &:hover {
        border: 1px solid $borderColorHover;
    }
}
</style>
